import { initialize } from 'react-localize-redux';
import { addTranslationForLanguage, setActiveLanguage } from 'react-localize-redux';
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import * as cookieServices from 'services/cookies/cookieServices';

const languages = ['en-US', 'it-IT', 'es-ES', 'de-DE', 'nl-NL'];
const defaultLangCode = 'en-US';

export function init(store){
    console.log("init localization with default lang " + defaultLangCode);

    const enjson = require('./translations/translations-en-us.json');
    const dejson = require('./translations/translations-de-de.json');
    const itjson = require('./translations/translations-it-it.json');
    const esjson = require('./translations/translations-es-es.json');
    const nljson = require('./translations/translations-nl-nl.json');

    /*
        defaultLanguage: se non è stato indicato con un setActiveLanguage
        allora di default viene caricata la lingua indicata
    */
    store.dispatch(initialize(languages, { defaultLanguage: defaultLangCode }));

    /*
        configurazione per react-redux-i18n
    */
    store.dispatch(addTranslationForLanguage(enjson, 'en-US'));
    store.dispatch(addTranslationForLanguage(itjson, 'it-IT'));
    store.dispatch(addTranslationForLanguage(esjson, 'es-ES'));
    store.dispatch(addTranslationForLanguage(dejson, 'de-DE'));
    store.dispatch(addTranslationForLanguage(nljson, 'nl-NL'));

    const translationsObject = {
        en: enjson,
        it: itjson,
        es: esjson,
        de: dejson,
        nl: nljson,
      };

    syncTranslationWithStore(store)
    store.dispatch(loadTranslations(translationsObject));
    store.dispatch(setLocale(defaultLangCode));

    console.log("init localization completed");
}

/**
 *
 * @param {new lang code} newLangCode
 * @param {store redux} dispatch
 */
export function setLanguage(newLangCode, store){

    var filter;
    if(newLangCode.length === 2)
    {
        /*
            ho un codice lingua di 2 caratteri: it-IT --> it
        */
        filter = languages.filter(x => x.toLowerCase().indexOf(newLangCode.toLowerCase()) === 0);
    }
    else{
        filter = languages.filter(x => x === newLangCode);
    }

    if(!filter)
    {
        console.log("setLanguage: " + defaultLangCode);
        store.dispatch(setActiveLanguage(defaultLangCode));
        /*
            configurazione per react-redux-i18n
        */
        store.dispatch(setLocale(defaultLangCode));
        cookieServices.saveLanguageCode(defaultLangCode);
        return;
    }

    if(filter.length === 0)
    {
        console.log("setLanguage: " + defaultLangCode);
        store.dispatch(setActiveLanguage(defaultLangCode));
        /*
            configurazione per react-redux-i18n
        */
        store.dispatch(setLocale(defaultLangCode));
        cookieServices.saveLanguageCode(defaultLangCode);
        return;
    }

    console.log("setLanguage: " + filter[0]);
    store.dispatch(setActiveLanguage(filter[0]));
    cookieServices.saveLanguageCode(filter[0]);
    /*
        configurazione per react-redux-i18n
    */
    store.dispatch(setLocale(filter[0]));
}


// WEBPACK FOOTER //
// ./src/services/localization/localizationServices.js